import api from "./api";


const COMMUNITY_PATH = "/community";



// =====================================
// 🔹 HELPERS
// =====================================


const mapComment = (comment = {}) => ({

  id: comment.id,


  author:
    comment.author ??
    comment.createdBy ??
    comment.user?.name ??
    "Okänd",


  text:
    comment.text ??
    "",


  createdAt:
    comment.createdAt ??
    comment.created_at ??
    null,

});






const mapPost = (post = {}) => ({

  id: post.id,


  author:
    post.author ??
    post.createdBy ??
    post.user?.name ??
    "Okänd",



  avatar:
    post.avatar ??
    post.user?.avatar ??
    null,



  title:
    post.title ??
    "",



  text:
    post.text ??
    "",




  type:
    post.type ??
    null,



  category:
    post.category ??
    "discussion",




  pinned:
    post.pinned ??
    false,




  // gammalt stöd

  likes:
    post.likes ??
    post.likesCount ??
    0,



  // nytt stöd

  likesCount:
    post.likesCount ??
    post.likes ??
    0,



  userLiked:
    post.userLiked ??
    false,



  userSaved:
    post.userSaved ??
    false,



  comments:

    Array.isArray(post.comments)

    ?

    post.comments.map(mapComment)

    :

    [],




 attachment:
  post.attachment ??
  (post.document_id
    ? {
        id: post.document_id,

        name:
          post.attachment_name ??
          post.attachment_filename ??
          "Dokument",

        filename:
          post.attachment_filename ??
          null,

        mimeType:
          post.attachment_type ??
          null,

        url:
          `${api.defaults.baseURL}/documents/${post.document_id}/download`,
      }
    : null),


  createdAt:
    post.createdAt ??
    post.created_at ??
    null,


});








// =====================================
// 📦 GET ALL POSTS
// =====================================


export const getCommunityPosts = async()=>{


  const res =
    await api.get(
      `${COMMUNITY_PATH}/posts`
    );



  return Array.isArray(res.data)

    ?

    res.data.map(mapPost)

    :

    [];

};









// =====================================
// 📂 GET CATEGORY
// =====================================


export const getCommunityPostsByCategory = async(
  category
)=>{


  if(!category)
    throw new Error(
      "category krävs"
    );



  const res =
    await api.get(
      `${COMMUNITY_PATH}/posts/category/${category}`
    );



  return Array.isArray(res.data)

    ?

    res.data.map(mapPost)

    :

    [];

};









// =====================================
// 👤 GET USER POSTS
// =====================================


export const getCommunityPostsByUser = async(
  userId
)=>{


  if(!userId)
    throw new Error(
      "userId krävs"
    );



  const res =
    await api.get(
      `${COMMUNITY_PATH}/posts/user/${userId}`
    );



  return Array.isArray(res.data)

    ?

    res.data.map(mapPost)

    :

    [];

};









// =====================================
// ➕ CREATE POST
// =====================================


export const createCommunityPost = async ({
  title,
  text,
  category,
  type = null,
  pinned = false,
  documentId = null,
}) => {
  if (!title && !text) {
    throw new Error("Innehåll krävs");
  }

  const res = await api.post(`${COMMUNITY_PATH}/posts`, {
    title,
    text,
    category,
    type,
    pinned,
    documentId,
  });

  return mapPost(res.data);
};









// =====================================
// ✏️ UPDATE POST
// =====================================


export const updateCommunityPost = async(
 id,
 updates={}
)=>{


 const res =
  await api.put(

    `${COMMUNITY_PATH}/posts/${id}`,

    updates

  );



 return mapPost(
  res.data
 );

};









// =====================================
// 🗑 DELETE POST
// =====================================


export const deleteCommunityPost = async(
 id
)=>{


 const res =
  await api.delete(

    `${COMMUNITY_PATH}/posts/${id}`

  );



 return res.data;

};









// =====================================
// 👍 LIKE / UNLIKE
// =====================================


export const likeCommunityPost = async(
 id
)=>{


 const res =
  await api.post(

    `${COMMUNITY_PATH}/posts/${id}/like`

  );



 return mapPost(
  res.data
 );

};









// =====================================
// 🔖 SAVE / UNSAVE
// =====================================


export const saveCommunityPost = async(
 id
)=>{


 const res =
  await api.post(

    `${COMMUNITY_PATH}/posts/${id}/save`

  );



 return mapPost(
  res.data
 );

};









// =====================================
// 💬 CREATE COMMENT
// =====================================


export const createCommunityComment = async({

 postId,

 text,


})=>{


 if(!postId)

   throw new Error(
    "postId krävs"
   );



 if(!text)

   throw new Error(
    "text krävs"
   );





 const res =
  await api.post(

   `${COMMUNITY_PATH}/posts/${postId}/comments`,

   {
    text
   }

  );



 return mapComment(
  res.data
 );

};









// =====================================
// 🗑 DELETE COMMENT
// =====================================


export const deleteCommunityComment = async(

 postId,

 commentId

)=>{


 const res =
  await api.delete(

   `${COMMUNITY_PATH}/posts/${postId}/comments/${commentId}`

  );



 return res.data;

};









// =====================================
// 📌 PIN / UNPIN
// =====================================


export const toggleCommunityPin = async(
 id
)=>{


 const res =
  await api.patch(

   `${COMMUNITY_PATH}/posts/${id}/pin`

  );



 return mapPost(
  res.data
 );

};









// =====================================
// 🔥 BACKWARD COMPATIBILITY
// =====================================


export const getPosts =
getCommunityPosts;



export const createPost =
createCommunityPost;



export const deletePost =
deleteCommunityPost;









// =====================================
// DEFAULT EXPORT
// =====================================


export default {


 getCommunityPosts,

 getCommunityPostsByCategory,

 getCommunityPostsByUser,


 createCommunityPost,

 updateCommunityPost,

 deleteCommunityPost,


 likeCommunityPost,

 saveCommunityPost,


 createCommunityComment,

 deleteCommunityComment,


 toggleCommunityPin,



 // gamla namn

 getPosts,

 createPost,

 deletePost,


};